import { RadioCardInterface } from '../interfaces/radio-card.interface';
import { RadioCardCoverageModel } from './radio-card-coverage.model';

export class RadioCardModel {
  priority?: number; // Sirve para comparar entre seguros cual es mas alto y por ello mas caro
  title: string;
  subTitle: string;
  price: string;
  desc1?: string;
  desc2?: string;
  desc3?: string;
  textOpenModal?: string;
  coverage?: RadioCardCoverageModel;
  checked?: boolean;
  budge?: any;

  constructor( obj: RadioCardInterface ) {

    this.priority = obj && obj.priority;
    this.title = obj && obj.title ? obj.title : '';
    this.subTitle = obj && obj.subTitle ? obj.subTitle : '';
    this.price = obj && obj.price ? obj.price : '';
    this.desc1 = obj && obj.desc1 ? obj.desc1 : '';
    this.desc2 = obj && obj.desc2 ? obj.desc2 : '';
    this.desc3 = obj && obj.desc3 ? obj.desc3 : '';
    this.textOpenModal = obj && obj.textOpenModal ? obj.textOpenModal : 'Cerrar';
    this.coverage = obj && obj.coverage ? new RadioCardCoverageModel( obj.coverage ) : null;
    // this.checked = obj && obj.checked !== undefined ? obj.checked : false;
    this.checked = false;
  }
}
